export default __webpack_public_path__ + "static/media/home-application-testimonial-img01.b27bd710.png";